import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 32.03",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M37.77 12.31q-7.32 5.05-11.12 7.85-1.27 1-2.06 1.49a12.66 12.66 0 0 1-2.11 1.09 6.33 6.33 0 0 1-2.48.56 6.33 6.33 0 0 1-2.46-.56 12.63 12.63 0 0 1-2.11-1.09q-.79-.53-2.06-1.49-3-2.25-11.09-7.85a11.89 11.89 0 0 1-2.25-2v18.08A3.54 3.54 0 0 0 1 31a3.41 3.41 0 0 0 2.57 1h32.86A3.41 3.41 0 0 0 39 31a3.54 3.54 0 0 0 1-2.57v-18.1a12.39 12.39 0 0 1-2.23 2zm1.17-11.24A3.42 3.42 0 0 0 36.43 0H3.57A3.16 3.16 0 0 0 .93 1.18a4.65 4.65 0 0 0-.93 3 5.37 5.37 0 0 0 1.23 3.07 11.18 11.18 0 0 0 2.61 2.62l4.58 3.24 5.85 4.15.95.69 1.21.86q.48.33 1.16.74a6.69 6.69 0 0 0 1.28.61 3.48 3.48 0 0 0 1.12.2 3.49 3.49 0 0 0 1.12-.2 6.7 6.7 0 0 0 1.28-.61q.68-.41 1.16-.74l1.24-.81.95-.69 10.44-7.44a10.72 10.72 0 0 0 2.72-2.8A6.09 6.09 0 0 0 40 3.64a3.52 3.52 0 0 0-1.06-2.57z",
			id: "Layer_1-2",
			"data-name": "Layer 1"
		})
	})
});
export default SvgIconEmail;
